// extracted by mini-css-extract-plugin
export default {"grid":"PostItem_grid__fhyOB","img":"PostItem_img__ZoTEb","content":"PostItem_content__vJq+5","details":"PostItem_details__B3rip","list":"PostItem_list__57ln6"};